import type { HomeSlice } from '../bs/home'

/**
 * Croatian overrides for the home screens.
 *
 * A short list — the home screen is mostly shared vocabulary. What moves:
 * *sigurnost* for safety, *stroj* for machine, *bodovi* for points, *što* for
 * *šta*, *tko* / *netko*, *usporediti* for *uporediti*, and *kriterij* rather
 * than *kriterijum*.
 */
export const home: Partial<HomeSlice> = {
  'home.report.text': 'Kvar, incident, sigurnost ili prijedlog za poboljšanje',
  'home.scan.text': 'Otvori prijavu za stroj pored kojeg stojiš',

  'home.stat.points': 'Osvojeni bodovi',
  'home.stat.points.explain':
    'Bodovi koje je komisija dala vašim prihvaćenim prijedlozima; u ocjenu na rang listi ulazi broj prihvaćenih, a ne bodovi.',

  'home.module.tasks.text': 'Što je dodijeljeno vama i vašem timu',
  'home.module.fiveS.text': 'Ocjena radnog centra po kriterijima',

  'home.fiveS.explain':
    'Prosjek pogona pored stoji samo da imate s čim usporediti svoj broj — to nije rang i nigdje ne piše na kojem ste mjestu.',

  // *stroj* for the machines, *tko* / *netko*, and *postotak* for *procenat*.
  'leaderboard.explain.note':
    'Dio za 5S govori o strojevima koje je netko održavao, a ne o njemu — tko je prešao na zapušten centar ima nizak postotak upravo zbog toga. Prihvaćeni prijedlozi se dodaju na osnovu i mogu je samo podići: odbijen prijedlog ne oduzima ništa. Tko nije bio ni na jednom obilasku ili nema nijedan zadatak, ocjenjuje se samo po onome što ima, a dio koji nedostaje se ne računa kao nula.',
  'leaderboard.explain.ties':
    'Isti rezultat dijeli isto mjesto: dvoje s 82 su oboje drugi, a sljedeći je četvrti.',
}
